<script>
export default {
  name: "Notifications",
  mounted() {
    window.location.href = 'https://notifications.izzy.cz/dashboard';
  }
}
</script>
